import axios from 'axios';

export const searchMatchesRequest = (search: string) =>
  axios.get(`/v1/matches/search?player=${search}`);

export const getBetsByMatchRequest = (id: string) =>
  axios.get(`/v1/matches/${id}/bets`);
